import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Drawer.ReportsMenu', {
    reportsName: 'Reports',
    requestName: 'Request reports',
    lineItemsName: 'Line item reports',
});
